/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpack_Popular1Inputs */

const zh_creditpack_popular1 = /** @type {(inputs: Creditpack_Popular1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门`)
};

const en_creditpack_popular1 = /** @type {(inputs: Creditpack_Popular1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular`)
};

const es_creditpack_popular1 = /** @type {(inputs: Creditpack_Popular1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular`)
};

/**
* | output |
* | --- |
* | "Popular" |
*
* @param {Creditpack_Popular1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const creditpack_popular1 = /** @type {((inputs?: Creditpack_Popular1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpack_Popular1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_creditpack_popular1(inputs)
	if (locale === "en") return en_creditpack_popular1(inputs)
	return es_creditpack_popular1(inputs)
});
export { creditpack_popular1 as "creditPack_popular" }